<template>
  <div id="app">
    <GlobalHeader ref="header" />
    <GlobalSidebar />
    <router-view class="container" />
    <GlobalFooter ref="footer" />
    <!-- <LinkImg /> -->
  </div>
</template>
<script>
import GlobalHeader from '@/components/GlobalHeader'
import GlobalFooter from '@/components/GlobalFooter'
import GlobalSidebar from '@/components/GlobalSidebar'
// import LinkImg from './views/HomePage/components/LinkImg'
export default {
  name: 'App',
  components: {
    GlobalHeader,
    GlobalSidebar,
    GlobalFooter,
    // LinkImg,
  },
  created() {
    const _this = this
    _this.$store.dispatch('resize')
    window.addEventListener('resize', function () {
      _this.$store.dispatch('resize')
    })
  },
  mounted() {
    let search = window.location.search
    let params = new URLSearchParams(search)
    if (params.get('ticketId')) {
      this.login(params.get('ticketId'))
    } else {
      this.$store.dispatch('getUserInfo').catch(() => {
        localStorage.removeItem('userInfo')
      })
    }
  },
  methods: {
    login(ticketId) {
      this.$http({ method: 'get', url: '/general/zlb/auth/login', params: { ticket: ticketId } }).then((res) => {
        this.$store.dispatch('getUserInfo').then(() => {
          window.location.href = window.location.href.replace(window.location.search, '')
        })
      })
    },
  },
}
</script>
<style scoped>
.container {
  min-height: calc(100vh - 130px - 7.0833vw - 4.1667vw);
}
</style>
